<template>
  <div id="app">
    <router-view />
    <FooterMenu v-if="telegramId" />
  </div>
</template>

<script>
import FooterMenu from './components/FooterMenu.vue';

export default {
  components: {
    FooterMenu
  },
  data() {
    return {
      telegramId: ''
    };
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.telegramId = urlParams.get('telegram_id');
  }
}
</script>

<style>
body {
  background-color: #000;
  color: #fff;
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

#app {
  background-color: #000;
  color: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
